<template>

  <div class="header_page">




    <div>
      <div class="w1200 mar_auto hp100">
        <div class="flex_box aic hp100">
          <img src="../assets/images/logo.png" width="100px"  alt=""/>
          <router-link to="/">
            <span class="no home_btn">首页</span>
          </router-link>
          <div class="item ov">
            <div class="search_box">
              <div class="flex_box hp100">
                <div class="item ov">
                  <div class="re">
                    <input v-model="keywords" type="text" class="ipt_search" placeholder="搜索关键词"/>
                    <img src="../assets/images/icon_search.png" class="ic_search_pos" alt=""/>
                  </div>
                </div>
                <div
                    @click="search"
                >
                  <span class="search_btn">搜索</span>
                </div>
              </div>
            </div>
          </div>
          <div class="back_top" @click="scrollToTop();">
            <img src="../assets/images/ic_top.png" class="ic_size" alt=""/>
            <span class="back_name">滚动至顶部</span>
          </div>
          <div class="lang_sw_box">
            <a  class="item_lang current" >中</a>
            <a href="https://cbegocloud.cbebaiwen.com/en/#/exhibitors/lists" class="item_lang "  >ENG</a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { EventBus } from './eventBus';
export default {
  name: 'Header',
  props: {},

  data() {
    return {
      t: 2,
      searchText: '',
      keywords:'',
      tabIndex: 0,
      language: localStorage.getItem("locale") || "zh",
    }
  },
  created() {
    if (this.$route.query.s) {
      this.keywords = this.$route.query.s;
    }
    if (this.$route.query.t) {
      this.t = this.$route.query.t;
    }
  },

  methods: {
    search() {
      sessionStorage.setItem("localkeywords", this.keywords);
      // 触发一个自定义事件，并传递搜索文本
      EventBus.$emit('searchPerformed', this.keywords);
      if(this.$route.name != 'search'){
        this.$router.push("/search/one");
      }
    },
    handleLangSw(lange) {
      localStorage.setItem("locale", lange);
      this.$i18n.locale = lange;
      localStorage.setItem("lang", lange);
      this.language = lange;
      location.reload(); //重新加载
    },


    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滚动
      });
    }

  }

}
</script>

<style scoped lang="less">
.header_page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: #A90000;
  z-index: 6;
  overflow: hidden;
}


.home_btn {
  position: relative;
  display: block;
  padding: 0 24px;
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  border-width: 0 1px 0 1px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.2);
  margin-left: 32px;
  margin-right: 32px;
}

.home_btn.no {
  color: #A90000;
  background: #fff;
  border-color: rgba(255, 255, 255, 1);
}

.back_top {
  position: relative;
  display: flex;
  align-items: center;
  height: 60px;
  cursor: pointer;

  .ic_size {
    width: 12px;
    height: 20px;
  }

  .back_name {
    position: relative;
    font-size: 16px;
    color: #fff;
    margin-left: 8px;
  }
}

.lang_sw_box {
  position: relative;
  display: flex;
  margin-left: 32px;

  .item_lang {
    position: relative;
    width: 50px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    cursor: pointer;

    &.current {
      color: #A90000;
      background: #fff;
    }
  }

}

.search_box {
  position: relative;
  width: 620px;
  height: 40px;
  border-radius: 4px;
  overflow: hidden;

  .ipt_search {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: left;
    padding: 0 12px 0 36px;
    font-size: 14px;
    color: #fff;
    font-weight: bold;
    background: rgba(255, 255, 255, .2);
    outline: none;
    border: 0;
    border-radius: 0;
    &::-webkit-input-placeholder {
      color: #fff;
    }
  }

  .ic_search_pos {
    position: absolute;
    top: 50%;
    left: 12px;
    width: 16px;
    height: 16px;
    z-index: 2;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
  }

  .search_btn {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 40px;
    font-size: 14px;
    color: #fff;
    font-weight: bold;
    background: #E94A13;
    cursor: pointer;
  }
}

</style>
